var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12C0 14.7614 2.23858 17 5 17H5.40192C5.39095 16.981 5.38017 16.9618 5.36959 16.9425C4.84287 15.9821 4.8815 14.8109 5.47034 13.8873L7.70167 10.3873C8.59235 8.9902 10.4469 8.57967 11.844 9.47034C13.1181 10.2826 13.5717 11.8966 12.9662 13.2341C13.2033 13.4398 13.4098 13.6842 13.5755 13.9616C14.117 14.868 14.142 15.9924 13.6415 16.9221L13.5996 17H14C17.3137 17 20 14.3137 20 11C20 8.3467 18.2777 6.09565 15.8902 5.30379C15.3287 2.28532 12.6812 0 9.5 0C5.91015 0 3 2.91015 3 6.5C3 6.80195 3.02059 7.0991 3.06044 7.39011C1.26232 8.14757 0 9.92637 0 12Z",
    fill: "#FEDE58"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0745 12.5376C11.3714 12.0719 11.2346 11.4537 10.7689 11.1568C10.3032 10.8599 9.685 10.9967 9.38811 11.4624L7.15678 14.9624C6.9605 15.2703 6.94762 15.6607 7.1232 15.9808C7.29877 16.301 7.63487 16.5 8 16.5H9.3259L8.23516 18.526C7.97335 19.0122 8.15533 19.6187 8.64162 19.8805C9.1279 20.1423 9.73435 19.9603 9.99616 19.474L11.8805 15.974C12.0473 15.6641 12.039 15.2893 11.8585 14.9872C11.678 14.685 11.352 14.5 11 14.5H9.82345L11.0745 12.5376Z",
    fill: "#FEDE58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.ca2fb6a654071e049530e166373d9ea9.svg";
export { ForwardRef as ReactComponent };